import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Bands } from "../../Banding/Types";
import { OutputConfigSlice } from "../../redux";
import { Actions } from "../OutputMappingButtonsBar/Types";
import { OutputMappingChild } from "../OutputMappingList/Types";
import { OUTPUT_CONFIG_MAP_HIGHLIGHT } from "../../Constant";
import { OutputMappingChildCardView } from "./OutputMappingChildCard.view";

interface Props {
  /**
   * Child config item
   */
  mappingChildItem: OutputMappingChild;
  /**
   * Child order to apply styles
   */
  layerId: number;
  /**
   * Pass band to parent
   * @param value bandtype
   */
  passToParent: (value: string) => void;
}

/**
 * Output mapping list card logic 
 */
export const OutputMappingChildCard: React.FC<Props> = (props: Props) => {
  const {
    mappingChildItem,
    layerId,
    passToParent
  } = props;
  const [selectedToggle, setSelectedToggle] = useState(Bands.AGE);
  const dispatch = useDispatch();
  /**
   * Action on Toggle Button Select
   * @param value selected band type
   */
  const onToggleButtonSelect = (value: number): void => {
    setSelectedToggle(value);
  };

  /**
   * Action on Manage Bandings dropdown is selected
   */
  const onManageBandingsClick = (band: string): void => {
    dispatch(OutputConfigSlice.actions.setSelectedOutputMapping(
      {
        status: true,
        action: Actions.CLOSE,
        band: band,
        configMapId: mappingChildItem.configMapId
      }));
  };

  /**
   * Action when Edit Config detail button is clicked
   */
  const onEditConfigDetail = (): void => {
    const element = document.getElementById(mappingChildItem.configMapId) ||
      document.getElementById(mappingChildItem.parentMapId);
    if (element && element.classList.contains(OUTPUT_CONFIG_MAP_HIGHLIGHT)) {
      element.classList.remove(OUTPUT_CONFIG_MAP_HIGHLIGHT);
    }
    dispatch(OutputConfigSlice.actions.setSelectedOutputMapping({
      status: true,
      action: Actions.MODIFY,
      band: Actions.CHILD,
      configMapId: mappingChildItem.configMapId
    }));

    dispatch(OutputConfigSlice.actions.setOutputMappingPopupEditConfigData({
      configMapId: mappingChildItem.configMapId,
      configName: mappingChildItem.configName,
      tag: mappingChildItem.tag,
      includeInOutput: mappingChildItem.includeInOutput
    }));
  };

  /**
   * Pass value to prev child
   */
  const passToPrev = (val: string): void => {
    passToParent(val);
  };

  return (
    <OutputMappingChildCardView
      mappingChildItem={mappingChildItem}
      layerId={layerId}
      onToggleButtonSelect={onToggleButtonSelect}
      selectedToggle={selectedToggle}
      onManageBandingsClick={onManageBandingsClick}
      onEditConfigDetail={onEditConfigDetail}
      passToParent={passToParent}
      passToPrev={passToPrev}
    />
  );
};
